/** Words on a group's History. */

// ---- who made a change
/** Changes from the sheet import. */
export const HISTORY_BY_IMPORT = "Sheet import";
/** Changes the app made by itself. */
export const HISTORY_BY_SYSTEM = "System";
/** Changes Tutoring made (old tutoring pay taken back out of a group, for example). */
export const HISTORY_BY_TUTORING = "Tutoring";
/** Changes made signed in on the site. */
export const HISTORY_BY_YOU = "You";
